import { html } from 'lit-html';
import { AddRecommendationItemJsEnv } from '../models/add_recommendation_item_js_env'
import { AddRecommendationItemControlAction } from '../actions/add_recommendation_item_control_action'
import { each } from '../../../core/component';
import {FolderType, RecommendationItemFolder} from "../models/folders";

export var radioNameAttr = "selected-folder";

export const grandChildrenInner = (grandchildrenFolder: RecommendationItemFolder, folderType: FolderType) => html`
<li>
  <label class="a-radiobtn">
    <span class="a-radiobtn_inner">
      <input type="radio" @click=${() => AddRecommendationItemControlAction.controlButtonDisabled()}
       name="${radioNameAttr}"
       data-folder-id="${grandchildrenFolder.folderInformation.folderId}"
       data-folder-name="${grandchildrenFolder.folderInformation.folderName}"
       data-folder-type="${folderType}">
      <span class="a-radiobtn_label">${grandchildrenFolder.folderInformation.folderName}(${grandchildrenFolder.folderInformation.count})</span>
    </span>
  </label>
</li>
`;

export const grandChildren = (childrenFolder: RecommendationItemFolder, folderType: FolderType) => html`
<li>
  <label class="a-radiobtn">
    <span class="a-radiobtn_inner">
      <input type="radio" @click=${() => AddRecommendationItemControlAction.controlButtonDisabled()}
       name="${radioNameAttr}"
       data-folder-id="${childrenFolder.folderInformation.folderId}"
       data-folder-name="${childrenFolder.folderInformation.folderName}"
       data-folder-type="${folderType}">
      <span class="a-radiobtn_label">${childrenFolder.folderInformation.folderName}(${childrenFolder.folderInformation.count})</span>
    </span>
  </label>
  <ul class="o-addfolderlist_list_child">
    ${ childrenFolder.childFolders.map((f) => grandChildrenInner(f, folderType)) }
  </ul>
</li>
`;

export const emptyGrandChildren = (childrenFolder: RecommendationItemFolder, folderType: FolderType) => html`
<li>
  <label class="a-radiobtn">
    <span class="a-radiobtn_inner">
      <input type="radio" @click=${() => AddRecommendationItemControlAction.controlButtonDisabled()}
         name="${radioNameAttr}"
         data-folder-id="${childrenFolder.folderInformation.folderId}"
         data-folder-name="${childrenFolder.folderInformation.folderName}"
         data-folder-type="${folderType}">
      <span class="a-radiobtn_label">${childrenFolder.folderInformation.folderName}(${childrenFolder.folderInformation.count})</span>
    </span>
  </label>
</li>
`;

export const childrenInner = (childrenFolder: RecommendationItemFolder, folderType: FolderType) => html`
<ul class="o-addfolderlist_list_child">
  ${ childrenFolder.childFolders.length > 0 ?
    grandChildren(childrenFolder, folderType) : emptyGrandChildren(childrenFolder, folderType)
  }
</ul>
`;

export const children = (childrenFolder: RecommendationItemFolder[], folderType: FolderType) => html`
  ${ each (childrenFolder, (it) => childrenInner(it, folderType)) }
`;

export const parent = (parentFolder: RecommendationItemFolder, folderType: FolderType) => html`
<li>
  <label class="a-radiobtn">
    <span class="a-radiobtn_inner">
      <input type="radio" @click=${() => AddRecommendationItemControlAction.controlButtonDisabled()}
        name="${radioNameAttr}"
        data-folder-id="${parentFolder.folderInformation.folderId}"
        data-folder-name="${parentFolder.folderInformation.folderName}"
        data-folder-type="${folderType}"
      >
      <span class="a-radiobtn_label">${parentFolder.folderInformation.folderName}(${parentFolder.folderInformation.count})</span>
    </span>
  </label>

  ${ parentFolder.childFolders.length > 0 ? children(parentFolder.childFolders, folderType) : "" }
</li>
`;

export const AccordionC = (model: AddRecommendationItemJsEnv) => {
  let isCompanyRecommendFolders = false
  if (model.companyRecommendationFolders != null && model.companyRecommendationFolders.length) {
      isCompanyRecommendFolders = true
  }
  return isCompanyRecommendFolders ? html`
         <button id="js-accordion-company-button" class="o-addfolderlist_hdg js-accordion_btn" type="button"
          @click=${() => AddRecommendationItemControlAction.companyAccordion()}
         >
           <span class="a-text u-text-bold">企業推奨品フォルダ</span>
         </button>
         <div id="js-accordion-target-company" class="o-addfolderlist_items js-accordionTarget">
           <div class="js-accordionTarget_inner">
             <ul class="o-addfolderlist_listRoot">
               ${ isCompanyRecommendFolders ? each (
                   model.companyRecommendationFolders,
                   (it) => parent(it, FolderType.Company)
                 ) : "" }
             </ul>
           </div>
         </div>
         ` : html``;
}

export const AccordionD = (model: AddRecommendationItemJsEnv) => {
  let isDepartmentRecommendFolders = false
  if (model.departmentRecommendationFolders != null && model.departmentRecommendationFolders.length) {
      isDepartmentRecommendFolders = true
  }
  return isDepartmentRecommendFolders ? html`
         <button id="js-accordion-department-button" class="o-addfolderlist_hdg js-accordion_btn" type="button"
          @click=${() => AddRecommendationItemControlAction.departmentAccordion()}
         >
           <span class="a-text u-text-bold">部門推奨品フォルダ</span>
         </button>
         <div id="js-accordion-target-department" class="o-addfolderlist_items js-accordionTarget">
           <div class="js-accordionTarget_inner">
             <ul class="o-addfolderlist_listRoot">
               ${ isDepartmentRecommendFolders ? each (
                 model.departmentRecommendationFolders,
                 (it) => parent(it, FolderType.Department)
               ) : "" }
             </ul>
           </div>
         </div>
         ` : html``;
}
